/**
 * Service Worker Registration
 * Registers SW for caching static assets and API responses
 */

export function registerServiceWorker() {
  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    // Register after load + idle to avoid competing with critical rendering work
    window.addEventListener('load', () => {
      const schedule = (cb: () => void) => {
        if (typeof window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
        return window.setTimeout(cb, 2500);
      };

      schedule(() => {
        navigator.serviceWorker
          .register('/sw.js')
          .then((registration) => {
            console.log('SW registered:', registration.scope);

            // Check for updates periodically
            setInterval(() => {
              registration.update();
            }, 60 * 60 * 1000); // Every hour
          })
          .catch((error) => {
            console.log('SW registration failed:', error);
          });
      });
    });
  }
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
